import React, { useState } from "react";
import { FaShareAlt, FaCopy, FaCheck } from "react-icons/fa";

const LinkItem = ({ label, url, Icon }) => {
  const [shared, setShared] = useState(false);
  const [isWebShare, setIsWebShare] = useState(!!navigator.share);

  const handleShare = async (e) => {
    e.preventDefault(); // Prevent navigation
    try {
      if (navigator.share) {
        await navigator.share({
          title: label,
          text: `Check this out: ${label}`,
          url: url,
        });
      } else {
        await navigator.clipboard.writeText(url);
      }
      setShared(true);
      setTimeout(() => setShared(false), 2000);
    } catch (error) {
      console.error("Share failed:", error);
    }
  };

  const renderShareIcon = () => {
    if (shared) return <FaCheck className="text-green-400" />;
    return isWebShare ? <FaShareAlt /> : <FaCopy />;
  };

  return (
    <div className="relative group block rounded-xl p-[2px] bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 hover:scale-105 transition-transform duration-300">
      <div
        className="flex items-center justify-between gap-3
          bg-gradient-to-r from-indigo-100 via-purple-100 to-pink-100
          dark:from-gray-800 dark:via-gray-900 dark:to-gray-800
          text-indigo-700 dark:text-white font-semibold py-3 px-6 
          rounded-xl transition-colors duration-300 group-hover:opacity-90"
      >
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3"
        >
          {Icon && <Icon size={22} />}
          {label}
        </a>

        <button
          onClick={handleShare}
          className="text-black dark:text-black hover:text-pink-300 transition"
          title={isWebShare ? "Share" : "Copy link"}
        >
          {renderShareIcon()}
        </button>
      </div>
    </div>
  );
};

export default LinkItem;
